var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as React from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TablePagination from "@mui/material/TablePagination";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { headCells, ShareRequestTableHeaders, SubShareRequestTableHeaders, UHF_BRAND, } from "./data";
import { openUrl, setOpenpopups } from "../handlers";
import NoEOSModal from "./NoEOSModal";
import ContributionModal from "./ContributionModal";
import { useCommonLoader } from "../../Loader";
import { Button } from "../../Button";
import styled from "@mui/material/styles/styled";
import { EnhancedTableHead } from "../../EnhancedTableHead";
import { getComparator, stableSort } from "../../EnhancedTableHead/handlers";
import Config from "../../../assests/config";
import ResponsiveMyShare from "./ResponsiveMyShare";
import { useMediaQuery, useTheme } from "@mui/material";
const ContributionModalStyle = styled(TableRow)(({ theme }) => ({
    ".FINAL span": {
        padding: 10,
        color: "#fff",
        borderRadius: 10,
        backgroundColor: "#27ae60",
    },
    ".Completed span": {
        padding: 10,
        color: "#fff",
        borderRadius: 10,
        backgroundColor: "#27ae60",
    },
    ".REVIEW span": {
        padding: 10,
        color: "#fff",
        borderRadius: 10,
        backgroundColor: "#eb5757",
    },
    ".Pending span": {
        padding: 10,
        color: "#fff",
        borderRadius: 10,
        backgroundColor: "#eb5757",
    },
}));
export function Row(props) {
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));
    const { row } = props;
    const [open, setOpen] = React.useState(false);
    const [viewDownloadModal, SetViewDownloadModal] = React.useState("");
    const [contributors, setContributors] = React.useState({
        data: null,
        totalContributors: "",
        message: "",
    });
    const isUHFBrand = React.useMemo(() => {
        return props.brand.toLowerCase() === Config.uhf;
    }, [props.brand]);
    const { setLoading, unSetLoading } = useCommonLoader();
    const openView = (bill_key) => {
        return () => __awaiter(this, void 0, void 0, function* () {
            setLoading();
            const data = yield setOpenpopups(bill_key);
            unSetLoading();
            setContributors(data);
        });
    };
    const getUrlLink = (bill_key) => {
        return () => __awaiter(this, void 0, void 0, function* () {
            setLoading();
            const link = yield openUrl(bill_key);
            unSetLoading();
            link
                ? window.open(link)
                : SetViewDownloadModal("No EOS data available. Please try again later.");
        });
    };
    return (React.createElement(React.Fragment, null,
        contributors.data ? (React.createElement(ContributionModal, Object.assign({}, contributors, { SetViewDownloadModal: SetViewDownloadModal }))) : null,
        viewDownloadModal ? (React.createElement(NoEOSModal, { SetViewDownloadModal: SetViewDownloadModal })) : null,
        isSmallScreen ? (React.createElement(Grid, { container: true },
            Object.keys(isUHFBrand
                ? UHF_BRAND.SubShareRequestTableHeaders
                : SubShareRequestTableHeaders).map((key) => {
                const title = isUHFBrand
                    ? UHF_BRAND.SubShareRequestTableHeaders[key].value
                    : SubShareRequestTableHeaders[key].value;
                console.clear();
                console.log(row);
                return (React.createElement(Grid, { item: true, xs: 6 },
                    React.createElement("label", { className: "Expense-Number221" }, title),
                    React.createElement("p", { className: "Expense-Number211" }, row[key])));
            }),
            !isUHFBrand ? (React.createElement(React.Fragment, null,
                React.createElement(Grid, { item: true, xs: 6 },
                    React.createElement("label", { className: "Expense-Number221" }, "Explanation of Sharing (EOS)"),
                    React.createElement("br", null),
                    React.createElement("br", null),
                    React.createElement(Button, { onClick: getUrlLink(row.bill_key), label: "VIEW/DOWNLOAD", variant: "outlined" })),
                React.createElement(Grid, { item: true, xs: 6 },
                    React.createElement("label", { className: "Expense-Number221" }, "Your Community Sharing"),
                    React.createElement("br", null),
                    React.createElement("br", null),
                    React.createElement(Button, { onClick: openView(row.bill_key), label: "VIEW", variant: "outlined" })))) : null)) : (React.createElement(React.Fragment, null,
            React.createElement(ContributionModalStyle, { sx: { "& > *": { borderBottom: "unset" } } },
                React.createElement(TableCell, null,
                    React.createElement(IconButton, { "aria-label": "expand row", size: "small", onClick: () => setOpen(!open) }, open ? React.createElement(KeyboardArrowUpIcon, null) : React.createElement(KeyboardArrowDownIcon, null))),
                Object.keys(isUHFBrand
                    ? UHF_BRAND.shareRequestTableHeaders
                    : ShareRequestTableHeaders).map((key) => (React.createElement(TableCell, { component: "th", scope: "row", className: row[key] },
                    React.createElement("span", null, row[key]))))),
            React.createElement(TableRow, { sx: { backgroundColor: "rgb(246, 246, 246)" } },
                React.createElement(TableCell, { style: { paddingBottom: 0, paddingTop: 0 }, colSpan: 12 },
                    React.createElement(Collapse, { in: open, timeout: "auto", unmountOnExit: true },
                        React.createElement(Box, { sx: { margin: 1 } },
                            React.createElement(Table, { size: "medium", "aria-label": "purchases" },
                                React.createElement(TableHead, null,
                                    React.createElement(TableRow, null,
                                        Object.keys(isUHFBrand
                                            ? UHF_BRAND.SubShareRequestTableHeaders
                                            : SubShareRequestTableHeaders).map((key) => (React.createElement(TableCell, { component: "th", scope: "row", style: {
                                                minWidth: isUHFBrand
                                                    ? UHF_BRAND.SubShareRequestTableHeaders[key]
                                                        .minWidth
                                                    : SubShareRequestTableHeaders[key].minWidth,
                                            } }, isUHFBrand
                                            ? UHF_BRAND.SubShareRequestTableHeaders[key].value
                                            : SubShareRequestTableHeaders[key].value))),
                                        !isUHFBrand ? (React.createElement(React.Fragment, null,
                                            React.createElement(TableCell, { style: { minWidth: 150 } }, "Explanation of Sharing (EOS)"),
                                            React.createElement(TableCell, { style: { minWidth: 150 } }, "Your Community Sharing"))) : null)),
                                React.createElement(TableBody, null,
                                    Object.keys(isUHFBrand
                                        ? UHF_BRAND.SubShareRequestTableHeaders
                                        : SubShareRequestTableHeaders).map((key) => (React.createElement(TableCell, { component: "th" }, row[key]))),
                                    !isUHFBrand ? (React.createElement(React.Fragment, null,
                                        React.createElement(TableCell, { align: "left", className: "innerTh number-View-download", onClick: getUrlLink(row.bill_key) },
                                            React.createElement(Button, { label: "VIEW/DOWNLOAD", variant: "outlined" })),
                                        React.createElement(TableCell, { align: "left", className: "innerTh number-View-download", onClick: openView(row.bill_key) },
                                            React.createElement(Button, { label: "VIEW", variant: "outlined" })))) : null))))))))));
}
const rows = [
    createData("600016", "2020-04-20", "VITALCARE FP LLC", 670, 43, "FINAL"),
];
function createData(no, date_of_service, provider, charged, paid, status) {
    return { no, date_of_service, provider, charged, paid, status };
}
const MyShareRequestsTableStyle = styled("div")(({ theme }) => ({
    ".eos-text": {
        [theme.breakpoints.up(1024)]: {
            width: "50%",
            position: "absolute",
        },
    },
}));
export default function MyShareRequestsTable(props) {
    var _a, _b, _c;
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [order, setOrder] = React.useState("asc");
    const [orderBy, setOrderBy] = React.useState("service_date");
    const [selected, setSelected] = React.useState([]);
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };
    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelecteds = rows.map((n) => n.name);
            setSelected(newSelecteds);
            return;
        }
        setSelected([]);
    };
    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === "asc";
        setOrder(isAsc ? "desc" : "asc");
        setOrderBy(property);
    };
    const isUHFBrand = React.useMemo(() => {
        return props.brand.toLowerCase() === Config.uhf;
    }, [props.brand]);
    if (isSmallScreen) {
        return React.createElement(ResponsiveMyShare, { data: props === null || props === void 0 ? void 0 : props.data, brand: props.brand });
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(TableContainer, { component: Paper, sx: { maxHeight: 440 } },
            React.createElement(Table, { "aria-label": "collapsible table", stickyHeader: true },
                React.createElement(EnhancedTableHead, { numSelected: selected.length, order: order, orderBy: orderBy, onSelectAllClick: handleSelectAllClick, onRequestSort: handleRequestSort, rowCount: rows.length, headCells: isUHFBrand ? UHF_BRAND.headCells : headCells }),
                React.createElement(TableBody, null, (_b = (_a = stableSort(props === null || props === void 0 ? void 0 : props.data, getComparator(order, orderBy))) === null || _a === void 0 ? void 0 : _a.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)) === null || _b === void 0 ? void 0 : _b.map((data, index) => {
                    return React.createElement(Row, { key: index, row: data, brand: props.brand });
                })))),
        React.createElement(MyShareRequestsTableStyle, { className: "table-bottom" },
            ((_c = props === null || props === void 0 ? void 0 : props.brand) === null || _c === void 0 ? void 0 : _c.toLowerCase()) === Config.uhf ? (React.createElement("p", { className: "eos-text" }, "** For complete status, please refer to the Explanation of Sharing (EOS) mailed to your address on file")) : null,
            React.createElement(TablePagination, { rowsPerPageOptions: [10, 25, 100], component: "div", count: props === null || props === void 0 ? void 0 : props.data.length, rowsPerPage: rowsPerPage, page: page, onPageChange: handleChangePage, onRowsPerPageChange: handleChangeRowsPerPage }))));
}
